import { render, staticRenderFns } from "./AddToNOD.vue?vue&type=template&id=51278f44&"
import script from "./AddToNOD.vue?vue&type=script&lang=js&"
export * from "./AddToNOD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports